export default __webpack_public_path__ + "static/media/img-66.9cc1222a.jpg";